import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { X, ChevronDown, ChevronRight } from 'lucide-react'
import mindImg from '../assets/images/mind.png'
import customer from '../assets/images/customer.png'
import visible from '../assets/images/visible.png'
import { ReactComponent as DashboardIcon } from '../assets/images/dashboard.svg'

const Sidebar = ({ isOpen, toggleSidebar, userEmail }) => {
  const location = useLocation()
  const [behaviorsOpen, setBehaviorsOpen] = useState(false)
  const [audienceOpen, setAudienceOpen] = useState(false)
  const [insightsOpen, setInsightsOpen] = useState(false)
  const [frameIQOpen, setFrameIQOpen] = useState(false)
  const [ytScrapperOpen, setYtScrapperOpen] = useState(false)  // ← NEW
  const [frameIqProductOpen, setFrameIqProductOpen] = useState(
    () => location.pathname.startsWith('/frame-iq')
  )

  const isActive = (path) => location.pathname === path

  const isFrameIQActive = () => {
    return location.pathname.startsWith('/campaign') || location.pathname === '/inspector'
  }

  // ← NEW: highlight YT Scrapper section when on /yt/* routes
  const isYtScrapperActive = () => {
    return location.pathname.startsWith('/yt/')
  }

  const ADMIN_EMAILS = ['anand.pathak@digiadglobal.com', 'sales@digidayin.com', 'shridhar.mishra@digiadglobal.com', 'educationat10@gmail.com', 'ashish.gupta@digiadglobal.com', 'anand.maheshwari@digiadglobal.com']
  const isAdmin = ADMIN_EMAILS.includes(userEmail)

  return (
    <>
      {isOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black bg-opacity-40 z-40 lg:hidden"
        ></div>
      )}

      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 lg:static lg:block`}
      >
        <div className="flex justify-end p-4 lg:hidden">
          <button onClick={toggleSidebar} className="text-gray-700">
            <X size={24} />
          </button>
        </div>

        <nav className="p-4">
          <ul className="space-y-2 text-lg text-gray-800">
            {/* Dashboard */}
            <li>
              <Link
                to="/dashboard"
                onClick={toggleSidebar}
                className={`flex items-center gap-3 px-3 py-2 rounded transition ${
                  isActive('/dashboard') ? 'bg-black text-white' : 'hover:bg-gray-100 text-gray-800'
                }`}
              >
                <DashboardIcon className="w-6 h-6" />
                Dashboard
              </Link>
            </li>

            {/* Behaviors Submenu */}
            <li>
              <button
                onClick={() => setBehaviorsOpen(!behaviorsOpen)}
                className="flex items-center justify-between w-full px-3 py-2 rounded hover:bg-gray-100"
              >
                <div className="flex items-center gap-3">
                  <img src={mindImg} alt="Mind" className="w-6 h-6" />
                  Behaviors
                </div>
                {behaviorsOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </button>

              {behaviorsOpen && (
                <ul className="pl-10 space-y-1 text-base text-gray-700">
                  <li>
                    <Link
                      to="/behaviors"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/behaviors') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Manage Behavior
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/custom-behavior"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/custom-behavior') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Custom Behavior
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Audience Submenu */}
            <li>
              <button
                onClick={() => setAudienceOpen(!audienceOpen)}
                className="flex items-center justify-between w-full px-3 py-2 rounded hover:bg-gray-100"
              >
                <div className="flex items-center gap-3">
                  <img src={customer} alt="Audience" className="w-6 h-6" />
                  Audience
                </div>
                {audienceOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </button>

              {audienceOpen && (
                <ul className="pl-10 space-y-1 text-base text-gray-700">
                  <li>
                    <Link
                      to="/audienceintrest"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/audienceintrest') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Manage Audience
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/custom-audience"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/custom-audience') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Custom Audience
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Insights Submenu */}
            <li>
              <button
                onClick={() => setInsightsOpen(!insightsOpen)}
                className="flex items-center justify-between w-full px-3 py-2 rounded hover:bg-gray-100"
              >
                <div className="flex items-center gap-3">
                  <img src={visible} alt="Insights" className="w-6 h-6" />
                  Insights
                </div>
                {insightsOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </button>

              {insightsOpen && (
                <ul className="pl-10 space-y-1 text-base text-gray-700">
                  <li>
                    <Link
                      to="/insights"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/insights') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Overview
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/topic-insights"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/topic-insights') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Topic Insights
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/topic-insights-realtime"
                      onClick={toggleSidebar}
                      className={`block py-1 transition ${
                        isActive('/topic-insights-realtime') ? 'text-black font-medium' : 'hover:text-black'
                      }`}
                    >
                      Topic Insights Real Time
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Upload CSV - Only for Admin */}
            {isAdmin && (
              <li>
                <Link
                  to="/csv-dashboard"
                  onClick={toggleSidebar}
                  className={`flex items-center gap-3 px-3 py-2 rounded transition ${
                    isActive('/csv-dashboard') ? 'bg-black text-white' : 'hover:bg-gray-100 text-gray-800'
                  }`}
                >
                  <img src={visible} alt="Upload" className="w-6 h-6" />
                  List And Upload CSV - Only Administrator
                </Link>
              </li>
            )}

            {/* Keyword Search - Only for Admin */}
            {isAdmin && (
              <li>
                <Link
                  to="/keyword-search"
                  onClick={toggleSidebar}
                  className={`flex items-center gap-3 px-3 py-2 rounded transition ${
                    isActive('/keyword-search') ? 'bg-black text-white' : 'hover:bg-gray-100 text-gray-800'
                  }`}
                >
                  <img src={visible} alt="Search" className="w-6 h-6" />
                  keyword-search - Only Administrator
                </Link>
              </li>
            )}

            {/* Frame IQ — AI video-analysis product (video_intelligence backend) - Admin Only with Submenu */}
            {isAdmin && (
              <li>
                <button
                  onClick={() => setFrameIqProductOpen(!frameIqProductOpen)}
                  className={`flex items-center justify-between w-full px-3 py-2 rounded transition ${
                    location.pathname.startsWith('/frame-iq') ? 'bg-black text-white' : 'hover:bg-gray-100'
                  }`}
                >
                  <div className='flex items-center gap-3'>
                    <img src={visible} alt='Frame IQ' className='w-6 h-6 flex-shrink-0' />
                    <span className='text-left'>Frame IQ</span>
                  </div>
                  {frameIqProductOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                </button>

                {frameIqProductOpen && (
                  <ul className='pl-10 space-y-1 text-base text-gray-700'>
                    <li>
                      <Link
                        to="/frame-iq"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/frame-iq') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        Frame Intelligence
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/frame-iq/showcase"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/frame-iq/showcase') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        Showcase
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}

            {/* Test IQ (formerly labeled "FrameIQ") - Admin Only with Submenu */}
            {isAdmin && (
              <li>
                <button
                  onClick={() => setFrameIQOpen(!frameIQOpen)}
                  className={`flex items-center justify-between w-full px-3 py-2 rounded transition ${
                    isFrameIQActive() ? 'bg-black text-white' : 'hover:bg-gray-100'
                  }`}
                >
                  <div className='flex items-center gap-3'>
                    <img src={visible} alt='Test IQ' className='w-6 h-6 flex-shrink-0' />
                    <span className='text-left'>Test IQ</span>
                  </div>
                  {frameIQOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                </button>

                {frameIQOpen && (
                  <ul className='pl-10 space-y-1 text-base text-gray-700'>
                    <li>
                      <Link
                        to="/inspector"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/inspector') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        Intelligence
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/campaign/list"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/campaign/list') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        List Campaign
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/campaign/download"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/campaign/download') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        Download Campaign
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}

            {/* ============================================ */}
            {/* Campaign IQ (formerly "YouTube Scrapper", briefly "Frame IQ") - Admin Only with Submenu */}
            {/* ============================================ */}
            {isAdmin && (
              <li>
                <button
                  onClick={() => setYtScrapperOpen(!ytScrapperOpen)}
                  className={`flex items-center justify-between w-full px-3 py-2 rounded transition ${
                    isYtScrapperActive() ? 'bg-black text-white' : 'hover:bg-gray-100'
                  }`}
                >
                  <div className='flex items-center gap-3'>
                    <img src={visible} alt='Campaign IQ' className='w-6 h-6 flex-shrink-0' />
                    <span className='text-left'>Campaign IQ</span>
                  </div>
                  {ytScrapperOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                </button>

                {ytScrapperOpen && (
                  <ul className='pl-10 space-y-1 text-base text-gray-700'>
                    <li>
                      <Link
                        to="/yt/campaign/create"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/yt/campaign/create') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        Create Campaign
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/yt/campaign/list"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/yt/campaign/list') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        List Campaigns
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/yt/campaign/download"
                        onClick={toggleSidebar}
                        className={`block py-1 transition ${
                          isActive('/yt/campaign/download') ? 'text-black font-medium' : 'hover:text-black'
                        }`}
                      >
                        Download
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}

          </ul>
        </nav>
      </div>
    </>
  )
}

export default Sidebar